var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-sso-login" }, [
      _c("div", { staticClass: "loader-wrapper" }, [
        _c("div", { staticClass: "loader-ring" }),
        _vm._v(" "),
        _c("img", {
          staticClass: "seedz-logo",
          attrs: {
            src: require("@/assets/images/icons/seedz-logo-loading.svg"),
            alt: "Seedz",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }